module.exports={
	"Form": "LineItemViewManifest",
	"Scope": "LineItem-View",
	"Descriptors":
	{
		"LineItemDetails.Name":
		{
			"Name": "Name",
			"Hash": "LineItem-View-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "LineItem-View-Identity",
				"Group": "LineItem-View-Identity"
			}
		},
		"LineItemDetails.ItemCode":
		{
			"Name": "Item Code",
			"Hash": "LineItem-View-ItemCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "LineItem-View-Identity",
				"Group": "LineItem-View-Identity"
			}
		},
		"LineItemDetails.Description":
		{
			"Name": "Description",
			"Hash": "LineItem-View-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 12,
				"Section": "LineItem-View-Details",
				"Group": "LineItem-View-Details"
			}
		},
		"LineItemDetails.Notes":
		{
			"Name": "Notes",
			"Hash": "LineItem-View-Notes",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 12,
				"Section": "LineItem-View-Details",
				"Group": "LineItem-View-Details"
			}
		},
		"LineItemDetails.Units":
		{
			"Name": "Units",
			"Hash": "LineItem-View-Units",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "LineItem-View-Details",
				"Group": "LineItem-View-Details"
			}
		},
		"LineItemDetails.SpecificationYear":
		{
			"Name": "Specification Year",
			"Hash": "LineItem-View-SpecificationYear",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "LineItem-View-Details",
				"Group": "LineItem-View-Details"
			}
		},
		"LineItemDetails.ItemNumber":
		{
			"Name": "Item Number",
			"Hash": "LineItem-View-ItemNumber",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "LineItem-View-Details",
				"Group": "LineItem-View-Details"
			}
		},
		"LineItemDetails.CostPerUnit":
		{
			"Name": "Cost Per Unit",
			"Hash": "LineItem-View-CostPerUnit",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "LineItem-View-Details",
				"Group": "LineItem-View-Details"
			}
		},
		"LineItemDetails.ExpectedQuantity":
		{
			"Name": "Expected Quantity",
			"Hash": "LineItem-View-ExpectedQuantity",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "LineItem-View-Details",
				"Group": "LineItem-View-Details"
			}
		},
		"LineItemDetails.ContractorReportedQuantity":
		{
			"Name": "Contractor Reported Quantity",
			"Hash": "LineItem-View-ContractorReportedQuantity",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "LineItem-View-Details",
				"Group": "LineItem-View-Details"
			}
		},
		"LineItemDetails.ActualQuantity":
		{
			"Name": "Actual Quantity",
			"Hash": "LineItem-View-ActualQuantity",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "LineItem-View-Details",
				"Group": "LineItem-View-Details"
			}
		},
		"LineItemDetails.ContractQuantity":
		{
			"Name": "Contract Quantity",
			"Hash": "LineItem-View-ContractQuantity",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "LineItem-View-Details",
				"Group": "LineItem-View-Details"
			}
		},
		"LineItemDetails.InstalledQuantity":
		{
			"Name": "Installed Quantity",
			"Hash": "LineItem-View-InstalledQuantity",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "LineItem-View-Details",
				"Group": "LineItem-View-Details"
			}
		},
		"LineItemDetails.ChangeOrderQuantity":
		{
			"Name": "Change Order Quantity",
			"Hash": "LineItem-View-ChangeOrderQuantity",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "LineItem-View-Details",
				"Group": "LineItem-View-Details"
			}
		},
		"LineItemDetails.ChangeOrderQuantityPending":
		{
			"Name": "Change Order Quantity Pending",
			"Hash": "LineItem-View-ChangeOrderQuantityPending",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "LineItem-View-Details",
				"Group": "LineItem-View-Details"
			}
		},
		"LineItemDetails.Tax":
		{
			"Name": "Tax",
			"Hash": "LineItem-View-Tax",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "LineItem-View-Details",
				"Group": "LineItem-View-Details"
			}
		},
		"LineItemDetails.ChangeOrderNumber":
		{
			"Name": "Change Order Number",
			"Hash": "LineItem-View-ChangeOrderNumber",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "LineItem-View-Details",
				"Group": "LineItem-View-Details"
			}
		},
		"LineItemDetails.FundingCategory":
		{
			"Name": "Funding Category",
			"Hash": "LineItem-View-FundingCategory",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "LineItem-View-Details",
				"Group": "LineItem-View-Details"
			}
		},
		"LineItemDetails.IDFundingCategory":
		{
			"Name": "Funding Category",
			"Hash": "LineItem-View-IDFundingCategory",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "8",
				"Width": 4,
				"Section": "LineItem-View-Details",
				"Group": "LineItem-View-Details",
				"Entity": "FundingCategory",
				"SearchFields":
				[
					"Name",
					"Code",
					"Description"
				],
				"ReadOnly": true
			}
		},
		"LineItemDetails.Status":
		{
			"Name": "Status",
			"Hash": "LineItem-View-Status",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "9",
				"Width": 4,
				"Section": "LineItem-View-Details",
				"Group": "LineItem-View-Details"
			}
		},
		"LineItemDetails.ProposalIdentifier":
		{
			"Name": "Proposal Identifier",
			"Hash": "LineItem-View-ProposalIdentifier",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "9",
				"Width": 4,
				"Section": "LineItem-View-Details",
				"Group": "LineItem-View-Details"
			}
		},
		"LineItemDetails.PercentComplete":
		{
			"Name": "Percent Complete",
			"Hash": "LineItem-View-PercentComplete",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "9",
				"Width": 4,
				"Section": "LineItem-View-Details",
				"Group": "LineItem-View-Details"
			}
		},
		"LineItemDetails.CategoryNumber":
		{
			"Name": "Category Number",
			"Hash": "LineItem-View-CategoryNumber",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "10",
				"Width": 4,
				"Section": "LineItem-View-Details",
				"Group": "LineItem-View-Details"
			}
		},
		"LineItemDetails.Retainage":
		{
			"Name": "Retainage",
			"Hash": "LineItem-View-Retainage",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "10",
				"Width": 4,
				"Section": "LineItem-View-Details",
				"Group": "LineItem-View-Details"
			}
		},
		"LineItemDetails.ImprovementType":
		{
			"Name": "Improvement Type",
			"Hash": "LineItem-View-ImprovementType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "10",
				"Width": 4,
				"Section": "LineItem-View-Details",
				"Group": "LineItem-View-Details"
			}
		},
		"LineItemDetails.DeliveryDate":
		{
			"Name": "Delivery Date",
			"Hash": "LineItem-View-DeliveryDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "11",
				"Width": 4,
				"Section": "LineItem-View-Details",
				"Group": "LineItem-View-Details"
			}
		},
		"LineItemDetails.ParentIDLineItem":
		{
			"Name": "Parent Line Item",
			"Hash": "LineItem-View-ParentIDLineItem",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "11",
				"Width": 4,
				"Section": "LineItem-View-Details",
				"Group": "LineItem-View-Details",
				"Entity": "LineItem",
				"SearchFields":
				[
					"Name",
					"ItemNumber"
				],
				"ReadOnly": true
			}
		},
		"LineItemDetails.IDPayItem":
		{
			"Name": "Pay Item",
			"Hash": "LineItem-View-IDPayItem",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "11",
				"Width": 4,
				"Section": "LineItem-View-Details",
				"Group": "LineItem-View-Details",
				"Entity": "PayItem",
				"SearchFields":
				[
					"Description",
					"ItemCode",
					"Name"
				],
				"ReadOnly": true
			}
		},
		"LineItemDetails.IDBidItem":
		{
			"Name": "Bid Item",
			"Hash": "LineItem-View-IDBidItem",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "12",
				"Width": 4,
				"Section": "LineItem-View-Details",
				"Group": "LineItem-View-Details",
				"Entity": "BidItem",
				"SearchFields":
				[
					"Name",
					"Description"
				],
				"ReadOnly": true
			}
		},
		"LineItemDetails.IDContract":
		{
			"Name": "Contract",
			"Hash": "LineItem-View-IDContract",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "12",
				"Width": 4,
				"Section": "LineItem-View-Details",
				"Group": "LineItem-View-Details",
				"Entity": "Contract",
				"SearchFields":
				[
					"Name",
					"Description",
					"PrimaryProjectNumber",
					"CountyProjectNumber"
				],
				"ReadOnly": true
			}
		},
		"LineItemDetails.IDProject":
		{
			"Name": "Project",
			"Hash": "LineItem-View-IDProject",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "12",
				"Width": 4,
				"Section": "LineItem-View-Details",
				"Group": "LineItem-View-Details",
				"Entity": "Project",
				"SearchFields":
				[
					"Name",
					"Description",
					"PurchaseOrderNumber",
					"ImprovementTypeCode"
				],
				"ReadOnly": true
			}
		},
		"LineItemDetails.FHWAEligible":
		{
			"Name": "FHWAEligible",
			"Hash": "LineItem-View-FHWAEligible",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "13",
				"Width": 3,
				"Section": "LineItem-View-Details",
				"Group": "LineItem-View-Details"
			}
		},
		"LineItemDetails.IDLineItem":
		{
			"Name": "IDLine Item",
			"Hash": "LineItem-View-IDLineItem",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "14",
				"Width": 4,
				"Section": "LineItem-View-DataAudit",
				"Group": "LineItem-View-DataAudit"
			}
		},
		"LineItemDetails.GUIDLineItem":
		{
			"Name": "GUIDLine Item",
			"Hash": "LineItem-View-GUIDLineItem",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "14",
				"Width": 4,
				"Section": "LineItem-View-DataAudit",
				"Group": "LineItem-View-DataAudit"
			}
		},
		"LineItemDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "LineItem-View-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "14",
				"Width": 4,
				"Section": "LineItem-View-DataAudit",
				"Group": "LineItem-View-DataAudit"
			}
		},
		"LineItemDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "LineItem-View-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "15",
				"Width": 4,
				"Section": "LineItem-View-DataAudit",
				"Group": "LineItem-View-DataAudit"
			}
		},
		"LineItemDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "LineItem-View-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "15",
				"Width": 4,
				"Section": "LineItem-View-DataAudit",
				"Group": "LineItem-View-DataAudit"
			}
		},
		"LineItemDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "LineItem-View-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "15",
				"Width": 4,
				"Section": "LineItem-View-DataAudit",
				"Group": "LineItem-View-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "LineItem-View-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "LineItem-View-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "LineItem-View-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "LineItem-View-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "LineItem-View-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "LineItem-View-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
